import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungErlangen() {
  return (
    <CityPageTemplate
      city="Erlangen"
      slug="erlangen"
      intro="Erlangen als Siemens-Stadt und Universitätsstadt – Deine Finanzplanung sollte genauso innovativ sein."
      description="Unabhängige & digitale Finanzberatung für Erlangen: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
